import { z } from 'zod';

export const emailSchema = z.string().email('Enter a valid email address');

export const workspaceNameSchema = z
  .string()
  .trim()
  .min(1, 'Workspace name is required')
  .max(60, 'Keep the name under 60 characters');

export const webhookUrlSchema = z
  .string()
  .url('Enter a valid URL')
  .refine((u) => u.startsWith('https://'), 'URL must use https');

// Optional/inherit-by-blank flows (onboarding destination overrides, persistent
// redirect URLs) treat '' as "inherit / unset". Blank must be VALID, not an
// error. Use this - NOT webhookUrlSchema - wherever the current UX allows blank.
export const optionalHttpsUrlSchema = z.union([z.literal(''), webhookUrlSchema]);
